import React from 'react'
import Link from 'next/link'
import moment from 'moment'
import { AdvisoryTileProps } from './SecurityAdvisories.interface'
import styles from './SecurityAdvisories.module.scss'
import Image from 'next/image'

import IconCalendarRed from '../../../public/assets/images/icon_calendar_red.svg'

const AdvisoryTile: React.FC<AdvisoryTileProps> = ({ advisory }) => {
  // NOTE: Date is already formatted in the Page component mapping, but we re-format it here for safety
  const formattedDate = moment(advisory.publishDate).format('MMM DD, YYYY').toUpperCase()

  return (
    <div className={`${styles.advisoryTile} font-dm-mono`}>
      <div className={styles.dateBox}>
        <span className={styles.calendarIcon}>
          <Image
            src={IconCalendarRed.src}
            alt="Date published:"
            width={14}
            height={14}
            className={`inline-block! align-middle ${styles.prevPage}`}
          />
        </span>
        <span className={styles.publishDate}>{formattedDate}</span>
      </div>
      <Link href={advisory.link} className={styles.tileLink}>
        <h2 className={`${styles.tileTitle} font-normal! text-[16px]!`}>{advisory.title}</h2>
      </Link>
    </div>
  )
}

export default AdvisoryTile
